import { useState, useEffect } from "react";

const HtmlRenderer = ({ fileUrl, attachments }) => {
  const [htmlContent, setHtmlContent] = useState("");

  const updateImageSources = (html, attachments) => {
    // Create a temporary DOM element to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Find all image elements inside the parsed HTML
    const images = tempDiv.querySelectorAll("img");

    images.forEach((img) => {
      const src = img.getAttribute("src");

      // Check if the src starts with "cid:"
      if (src && src.startsWith("cid:")) {
        const fileName = src.replace("cid:", ""); // Extract file name (e.g., "test2.png")

        // Find the matching file in the attachments array
        const matchedFile = attachments.find(
          (att) => att.attachmentName === fileName
        );

        if (matchedFile) {
          img.setAttribute("src", matchedFile.fileUrl); // Replace with actual file URL
        }
      }
    });

    // Return the updated HTML as a string
    return tempDiv.innerHTML;
  };

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        const response = await fetch(fileUrl);
        const text = await response.text();
        const formattedHtml = updateImageSources(text, attachments);
        setHtmlContent(formattedHtml);
      } catch (error) {
        console.error("Error fetching HTML file:", error);
      }
    };

    fetchHtml();
  }, [fileUrl, attachments]);

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default HtmlRenderer;
